<template>
  <div class="medlinker-warp">
    <div class="medlinker-title">医联产品</div>
    <div class="medlinker-content">
      <!-- 条件查询 -->
      <el-form inline :model="searchForm" class="search">
        <el-form-item label="产品名称">
          <el-input v-model="searchForm.comboName" placeholder="请输入产品名称" />
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="content-warp">
        <!-- <div class="type-warp">
          <div class="warp-title">归属医生</div>
          <div class="list-warp">
            <div class="list-item" :class="activeDoctorId == item.doctorId ? 'type-active' : ''"
              v-for="(item, i) in doctorList" :key="item.doctorId" :index="String(i + 1)"
              @click="changeActiveDoctor(item.doctorId)">
              <div>{{ item.doctorName }}</div>
            </div>
          </div>
        </div> -->
        <div class="type-warp">
          <div class="warp-title">产品名称</div>
          <div class="list-warp">
            <vuedraggable forceFallback="true" fallbackClass="fallbackClass" v-model="comboList"
              @end="comboListDraggableEnd">
              <div class="list-item" :class="activeComboId == item.comboId ? 'active' : ''"
                v-for="(item, i) in comboList" :key="item.comboId" :index="String(i + 1)"
                @click="changeActiveCombo(item.comboId)">
                <div>{{ item.comboName }}</div>
              </div>
            </vuedraggable>
          </div>
          <div class="add-warp" @click="addCombo"><i class="el-icon-plus"></i> 新增处方模版</div>
        </div>
        <div class="recipe-warp">
          <div class="warp-title display-f just-b" v-if="comboInfo">
            <div>{{ comboInfo.comboName }}</div>
            <div>
              <el-button type="primary" @click="editCombo">编辑</el-button>
              <el-button type="danger" plain @click="delCombo">删除</el-button>
            </div>
          </div>
          <div class="recipe-content" v-if="comboInfo">
            <div class="content-desc">
              <div class="desc-label">名称</div>
              <div class="desc-value">{{ comboInfo.comboName }}</div>
            </div>
            <div class="content-desc">
              <div class="desc-label">加工费</div>
              <div class="desc-value">{{ comboInfo.processFee }}</div>
            </div>
          </div>
          <div class="recipe-detail" v-if="comboInfo">
            <div class="detail-list" v-if="comboInfo.items.length > 0">
              <div class="list-item" v-for="item in comboInfo.items" :key="item.spuId">
                <div class="display-f just-b fwb">
                  <div>{{ item.drugName }}</div>
                  <div>{{ item.number }} {{ item.unit }}</div>
                </div>
                <div class="color6671 mt4">{{ item.handling }}</div>
              </div>
            </div>
            <div v-else class="tac pt50">暂无药品</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增或编辑弹框 模板 -->
    <addComboDialog v-if="comboVisible" :activeDoctorId="activeDoctorId" :comboTypeAction="comboTypeAction"
      :activeComboId="activeComboId" :form="editRecipeForm" :dialogShow="comboVisible" :title="comboTitle"
      @templateCancel="templateCancel" @saveSuceess="saveSuceess">
    </addComboDialog>
  </div>
</template>

<script>
import vuedraggable from 'vuedraggable'; // 拖拽组件
import { comboDTO } from '@/DTO/index'
import { isNull, deepClone, debounce, isEmptyArray } from '@/utils/validateBase';
import addComboDialog from './addComboDialog.vue'
export default {
  // 定义引入的组件
  components: { vuedraggable, addComboDialog },
  props: {},
  data() {
    return {
      dragOptions: {
        animation: 200,
        filter: '.action'
      },
      searchForm: {
        name: ''
      },
      doctorList: [],//医生列表
      activeDoctorId: '',//当前激活的医生id
      activeComboId: '',//当前激活的医联id
      comboList: [],//医联产品列表
      comboVisible: false,//是否显示弹框
      comboTitle: '',//弹框名称
      comboTypeAction: 'add',//操作类型
      comboInfo: null,
    }
  },
  //变量监听
  watch: {},
  // 页面初始化
  async created() {
    await this.getDocList()
    await this.getComboList()
    await this.getCombo()
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    /**
     * 获取医生列表
     */
    async getDocList() {
      let { code, data } = await comboDTO.getComboDocDTO()
      if (code = 200) {
        this.doctorList = isNull(data) ? [] : data
        if (isNull(this.activeDoctorId)) {
          this.activeDoctorId = isNull(data) ? '' : data[0].doctorId
        }
      }
    },
    /**
     * 获取医联产品列表
     */
    async getComboList() {
      if (isNull(this.activeDoctorId)) return
      let { code, data } = await comboDTO.getComboListDTO({ doctorId: this.activeDoctorId, ...this.searchForm })
      if (code == 200) {
        this.comboList = isNull(data) ? [] : data
        this.comboList = _.sortBy(this.comboList, function (item) { return item.sort })
        if (isNull(this.activeComboId)) {
          if (isEmptyArray(data) || isNull(data)) {
            this.comboInfo = null
          }
          this.activeComboId = isEmptyArray(data) ? '' : data[0].comboId
        }
      }
    },
    /**
     * 获取医联详情
     */
    async getCombo() {
      if (isNull(this.activeComboId)) return;
      let { code, data } = await comboDTO.getComboDTO(this.activeComboId)
      if (code == 200) {
        this.comboInfo = isNull(data) ? null : data
      }
    },
    /**
     * 搜索
     */
    search: debounce(function () {
      this.activeComboId = null
      this.getComboList()
    }, 300),
    /**
     * 重置
     */
    reset() { },
    /**
     * 拖拽结束
     */
    async comboListDraggableEnd(obj) {
      let targetIndex = null
      let length = this.comboList.length
      let { newIndex } = obj
      let src = this.comboList[newIndex].comboId
      if (newIndex + 1 < length) targetIndex = newIndex + 1
      let target = isNull(targetIndex) ? null : this.comboList[targetIndex].comboId
      let { code, data } = await comboDTO.moveComboDTO({ src, target })
      if (code == 200) {
        this.getComboList()
      }
    },
    /**
     * 切换医生
     */
    async changeActiveDoctor(doctorId) {
      this.activeDoctorId = doctorId
      this.activeComboId = null
      await this.getComboList()
      await this.getCombo()
    },
    /**
     * 切换产品
     */
    changeActiveCombo(comboId) {
      this.activeComboId = comboId
      this.getCombo()
    },
    /**
     * 新增医联
     */
    addCombo() {
      let items = []
      items.push({
        spuId: '',
        drugName: '',
        number: '',
        unit: 'g',
        deleteShow: false,//是否显示删除icon
        handling: '',
      })
      this.editRecipeForm = {
        comboName: '', doctorId: this.activeDoctorId, comboId: this.activeComboId, processFee: '', items: items, drugForm: '0'
      }
      this.comboTitle = "新增医联产品";
      this.comboTypeAction = 'add'
      this.comboVisible = true;
    },
    /**
     * 取消
     */
    templateCancel() {
      this.comboVisible = false
    },
    /**
     * 保存成功
     */
    async saveSuceess(data) {
      this.activeDoctorId = data.doctorId
      this.activeComboId = data.comboId
      this.comboVisible = false
      await this.getDocList()
      await this.getComboList()
      await this.getCombo()
    },
    /**
     * 编辑
     */
    editCombo() {
      this.editRecipeForm = { ...deepClone(this.comboInfo), doseType: '2' }
      this.comboTitle = "编辑医联产品";
      this.comboTypeAction = 'edit'
      this.comboVisible = true;
    },
    /**
     * 删除医联产品
     */
    delCombo() {
      this.$confirm('确认删除该医联产品？').then(_ => { this.handleDel() }).catch(_ => { });
    },
    /**
     * 执行删除
     */
    async handleDel() {
      let { code, data } = await comboDTO.removeComboDTO({ comboId: this.comboInfo.comboId })
      if (code == 200) {
        this.activeComboId = null
        this.$message.success("删除处方成功！");
        await this.getComboList()
        await this.getCombo()
      }
    },

  },
}
</script>
<style lang="less" scoped src="./medlinker.less"></style>./addComboDialog.vue